<template lang="html">

  <v-app-bar
    app
    :inverted-scroll="!$vuetify.breakpoint.mobile"
    :scroll-threshold="getScrollThreshold"
    :extension-height="getExtensionHeight"
    >

    <v-img class="" :src="this.getLogoPath" :alt="this.platform" max-height="56" max-width="100" contain>
    </v-img>
    <v-spacer></v-spacer>
    <v-row no-gutters class="hidden-xs-only pa-4 justify-end">
        <v-btn text v-for="(header, i) in headingSections" :key="i" @click="$vuetify.goTo('#'+header.anchor, {} )">
            {{header.name}}
        </v-btn>
    </v-row>
    <v-btn class="hidden-sm-and-up" icon v-model="extend" @click="extend = !extend">
      <v-icon v-show="!extend">mdi-menu</v-icon>
      <v-icon v-show="extend">mdi-close</v-icon>
    </v-btn>

    <template v-slot:extension v-show="!extend">
      <v-row v-show="extend">
          <v-col cols=12 class="shrink d-block transparent text-center" v-for="(header, i) in headingSections" :key="i">
              <v-list-item-title @click="$vuetify.goTo('#'+header.anchor, {} )">{{ header.name }}</v-list-item-title>
          </v-col>
      </v-row>
    </template>

  </v-app-bar>

</template>

<script>

export default {
    name: "AppBar",
    props: {
      headingSections: Array
    },
    data: () => {
        return {
            extend: false,
            platform: process.env.VUE_APP_PLATFORM,
        }
    },
    computed: {
      getScrollThreshold(){
        return this.$vuetify.breakpoint.mobile ? undefined : 300;
      },
      getExtensionHeight(){
        return this.extend ? 200 : 0;
      },
      getLogoPath(){
        return this.platform === 'Alumnier' ?
          require('@/assets/Alumnier_logo.png'):
          require('@/assets/Iceverg_logo.png');
      }
    }
}

</script>
